import * as React from 'react';
import type { SVGProps } from 'react';
const SvgLink = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    {...props}
  >
    <path
      fill="#A5A5AA"
      d="m21.165 5.224-2.393-2.39a2.849 2.849 0 0 0-4.03 0L11.628 5.95a2.849 2.849 0 0 0 0 4.03l.504.503-1.648 1.648-.504-.504a2.849 2.849 0 0 0-4.029 0l-3.115 3.116a2.849 2.849 0 0 0 0 4.03l2.393 2.392a2.849 2.849 0 0 0 4.03 0l3.115-3.115a2.85 2.85 0 0 0 0-4.03l-.504-.503 1.648-1.648.504.504a2.85 2.85 0 0 0 4.029 0l3.115-3.116a2.854 2.854 0 0 0 0-4.033Zm-10.17 10.175a.884.884 0 0 1 0 1.253l-3.116 3.116a.888.888 0 0 1-1.257 0l-2.39-2.39a.888.888 0 0 1 0-1.257l3.116-3.112a.888.888 0 0 1 1.257 0l.504.504-1.71 1.714a.98.98 0 0 0 1.358 1.413l.028-.027 1.71-1.714.5.5Zm8.784-7.532-3.111 3.112a.884.884 0 0 1-1.254 0l-.503-.504 1.714-1.714a.98.98 0 0 0-1.359-1.413l-.027.027-1.714 1.71-.504-.495a.888.888 0 0 1 0-1.258l3.116-3.115a.888.888 0 0 1 1.257 0l2.39 2.39a.89.89 0 0 1-.005 1.26Z"
    />
  </svg>
);
export default SvgLink;
